<template>
    <section class="events">
        <div class="heading">
            <div class="container-mobile" style="display: flex; justify-content: space-between; flex-wrap-wrap">
                <h1>{{ $t("balance.balance") }}: {{ formatBalance(user.balance) }}</h1>
            </div>
        </div>

        <div class="balance-heading-wrapper-link heading-link">
            <div>{{ $t("balance.referralLink") }}:</div>
            <div class="balance-ref-link" :class="{ 'ref-link-copied': copied }">
                {{ url_ref }}
            </div>
            <div @click="copyLink" class="balance-copy-link">
                {{ $t("balance.copyLink") }}
            </div>
        </div>

        <div class="info-block container-mobile" v-if="eventsBalance">
            <div class="user-list" v-if="eventsBalance.length > 0">
                <div class="user-item" v-for="item in eventsBalance" :key="item.id">
                    <!-- Аватарка -->
                    <router-link v-if="item.user && item.user.avatar" :to="'/profile/' + item.user.id" :style="{
                        'background-image': item.user.avatar
                            ? 'url(' + item.user.avatar + ')'
                            : '',
                    }" class="user-item-avatar" :class="{ 'no-avatar': !item.user.avatar }"></router-link>
                    <router-link v-else :to="'/profile/' +
                        (item.user && item.user.avatar ? item.user.avatar : '')
                        " :style="{
        'background-image':
            item.user && item.user.avatar
                ? 'url(' + item.user.avatar + ')'
                : '',
    }" class="user-item-avatar" :class="{ 'no-avatar': !item.user || !item.user.avatar }"></router-link>

                    <!-- Блок с информацией -->
                    <div class="user-item-info">
                        <div v-if="item.user && item.user.name && item.event_type !== 1">
                            <div>
                                {{ $t("balance.user") }}
                                <router-link :to="'/profile/' + item.user.id" class="user-item-title">
                                    {{ item.user.name }}
                                </router-link>
                                {{ $t("balance.signedUpYourLink") }}
                            </div>
                        </div>
                        <div class="user-item-subtitle">
                            <!-- Текст -->
                            <div v-if="item.event_type !== 6 &&
                                item.event_type !== 1 &&
                                !item.extra.days_strike &&
                                !item.extra.game &&
                                !item.extra[0]
                                ">
                                {{ item.event_type === 4 ? $t("balance.balanceReplenishment") : '' }}
                            </div>

                            <div v-if="item.event_type === 2">
                                {{ $t("balance.rouletteNumber") }}
                                {{ item.extra.winning_number }}
                                {{ $t("balance.andWon") }}
                            </div>

                            <!-- Пазл -->
                            <div v-if="item.event_type == 1">
                                <div>
                                    {{ $t("balance.user") }}
                                    <router-link :to="'/profile/' + item.user.id" class="user-item-title">
                                        {{ item.user.name }}
                                    </router-link>
                                    {{ $t("balance.boughtYourPuzzle") }}
                                </div>
                            </div>
                            <div v-if="item.extra && item.extra.length > 0 && item.extra[0].image
                                " class="events-img-wrapper">
                                <img v-if="item.extra && item.extra[0] && item.extra[0].image" :src="item.extra[0].image"
                                    alt="Пазл" class="events-img" />
                            </div>

                            <!-- Победа в игре -->
                            <div v-if="item.extra.game" class="user-item-subtitle">
                                {{ $t("balance.youWonGame") }}
                                <strong class="user-item-title-strong">
                                    «{{ item.extra.game }}»
                                </strong>
                            </div>

                            <!-- Заходили на сайт -->
                            <div v-if="item.extra.days_strike" class="user-item-subtitle">
                                {{ $t("balance.haveAccessedSite") }}
                                <strong class="user-item-title-strong">{{
                                    item.extra.days_strike
                                }}</strong>
                                {{ $t("balance.daysInRow") }}
                            </div>

                            <!-- Пополнение баланса -->
                            <div v-if="item.extra">
                                <div class="user-item-subtitle" v-if="item.extra.balance_add">
                                    {{ $t("balance.balanceReplenishment") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            + {{ item.extra.balance_add }}
                                        </strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.photos">
                                    {{ $t("balance.photos") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            + {{ item.extra.photos }}</strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.puzzle">
                                    {{ $t("balance.puzzle") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            + {{ item.extra.puzzle }}</strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.video">
                                    {{ $t("balance.video") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            + {{ item.extra.video }}</strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.story">
                                    {{ $t("balance.story") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            + {{ item.extra.story }}</strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.likes">
                                    {{ $t("balance.likes") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            {{ item.extra.likes }}</strong>
                                    </span>
                                </div>
                                <div class="user-item-subtitle" v-if="item.extra.liked">
                                    {{ $t("balance.liked") }}:
                                    <span>
                                        <strong class="user-item-title-strong">
                                            {{ item.extra.liked }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <span v-if="item.time">
                            <div class="user-item-bottom">
                                <strong>{{ $t("balance.date") }}:</strong>
                                {{ getShortDMY(item.time * 1000) }}
                                {{ getHM(item.time * 1000) }}
                            </div>
                        </span>
                    </div>

                    <!-- Блок баланса -->
                    <div class="balance-add" v-if="item.event_type !== 2">
                        <div class="balance-text balance-text-addition">
                            <span style="display: flex; align-items: center" class="balance-add-wrapper"
                                v-if="item.extra && item.extra.balance_add">
                                <strong style="margin-right: 5px; font-size: 16px">
                                    +{{ item.extra.balance_add }}
                                </strong>
                                <img width="16" src="../assets/img/dice-black.svg" alt="Баланс" />
                            </span>

                            <span style="display: flex; align-items: center" class="balance-add-wrapper"
                                v-if="item.extra && item.extra[0] && item.extra[0].balance_add">
                                <strong style="margin-right: 5px; font-size: 16px">
                                    +{{ item.extra[0].balance_add }}
                                </strong>
                                <img width="16" src="../assets/img/dice-black.svg" alt="Баланс" />
                            </span>

                            <span style="display: flex; align-items: center" class="balance-add-wrapper"
                                v-if="item.extra && item.extra.prize">
                                <strong style="margin-right: 5px; font-size: 16px">+{{ item.extra.prize }}</strong>
                                <img width="16" src="../assets/img/dice-black.svg" alt="Баланс" />
                            </span>

                            <span style="display: flex; align-items: center" class="balance-add-wrapper"
                                v-if="item.extra && item.extra.amount">
                                <strong style="margin-right: 5px; font-size: 16px">+{{ item.extra.amount }}</strong>
                                <img width="16" src="../assets/img/dice-black.svg" alt="Баланс" />
                            </span>
                        </div>
                    </div>

                    <div class="balance-add" v-if="item.event_type === 2">
                        <div class="balance-text balance-text-addition">
                            <span class="balance-add-wrapper" style="display: flex; align-items: center;">
                                <img :src="item.extra.prize.image" width="68" alt="">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { observeListEnd } from "@/mixins/observeListEnd";
import { formatDateTime } from "@/mixins/formatDateTime";

export default {
    name: "Balance",
    props: {
        i18n: Object,
    },
    data() {
        return {
            pageLoader: true,
            copied: false,
        };
    },
    mixins: [observeListEnd, formatDateTime],
    computed: {
        ...mapGetters({
            eventsBalance: "eventsBalance/eventsBalance",
            url_ref: "eventsBalance/url_ref",
            user: "user/fetchUser",
            eventsIsEmpty: "events/isEmpty",
            userIsEmpty: "user/isEmpty",
            events: "events/fetchEvents",
            refCode: "refCode/refCode",
        }),
    },
    created() {
        this.getEventsBalance();
        this.getEvents();
    },
    methods: {
        ...mapActions("eventsBalance", ["getEventsBalance"]),
        getEvents() {
            this.$store
                .dispatch("events/get")
                .then(() => {
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                    this.decrementCounter();
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        getEventsBalance() {
            this.$store
                .dispatch("eventsBalance/getEventsBalance")
                .then(() => {
                    this.pageLoader = false;
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        copyLink() {
            const el = document.createElement("textarea");
            el.value = this.url_ref;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
        },
        formatBalance(balance) {
            if (typeof balance == "number") {
                return balance;
            }
            let arr = balance.split(".");
            return arr[1] == "00" ? arr[0] : balance;
        },
    },
};
</script>


<style lang="scss">
@import "~@/assets/styles/pages/_balance.scss";
@import "~@/assets/styles/pages/_profile";
@import "~@/assets/styles/pages/_events";
</style>
